import React, { useEffect, useMemo, useState, useContext } from 'react';
import celebs_categories from '../static/celebs_categories.json';
import { getLocal, setLocal } from '../components/utilsSocial';
import { LangContext } from './langContext';
import { parseDesignInPersonas, _getCeleb } from '../components/utilsDesign';

var Airtable = require('airtable');

const CelebsContext = React.createContext();

function CelebsProvider({ children }) {

  const { language } = useContext(LangContext) || { language: 'en' };

  const AIRTABLE_URL = process.env.REACT_APP_AIRTABLE_URL;
  const AIRTABLE_APIKEY = process.env.REACT_APP_AIRTABLE_APIKEY;
  const APP_AIRTABLE_CACHE = process.env.REACT_APP_AIRTABLE_CACHE;
  const celebsTable = process.env.REACT_APP_AIRTABLE_CELEBS;

  var base = new Airtable({ apiKey: AIRTABLE_APIKEY }).base(AIRTABLE_URL);

  const [celebs, setCelebs] = useState(
    celebsTable !== 'celebs_dev' 
      && getLocal('data') 
      && getLocal('data').celebs 
        ? getLocal('data').celebs 
        : {}
  );

  console.log('celebsTable = ', celebsTable);

  useEffect(() => {
    if (celebsTable === 'celebs_dev' && !Object.keys(celebs).length) {
      base(celebsTable).select({
        maxRecords: 100,
      }).eachPage(function page(records, fetchNextPage) {
        const results = {};
        records
          .filter(one => one.get('active'))
          .filter(one => one.get('hd_id'))
          .forEach(one => {
            results[one.get('hd_id')] = ({
              'id': one.get('id'),
              'hd_id': one.get('hd_id') ? one.get('hd_id') : '',
              'type': one.get('type') ? one.get('type') : [],
            })
          })
        setCelebs(results)
      }, function done(err) {
        if (err) {
          console.log(err);
          setCelebs({})
          return;
        }
      });
    }
  }, []);

  const [celebsData, setCelebsData] = useState([]);
  const [isLoadingCelebs, setIsLoadingCelebs] = useState(false);

  useEffect(() => {
    if (Object.keys(celebs).length > 0 && celebsData.length === 0 && !isLoadingCelebs) {
      const fetchedUserIds = new Set();
      let isMounted = true; // Flag to prevent state updates after unmount

      const fetchUser = async (userId) => {
        try {
          if (fetchedUserIds.has(userId)) {
            return null;
          }

          const userData = await new Promise((resolve) => {
            _getCeleb(userId, (userData) => {
              resolve(userData);
            }, (error) => {
              console.log('Error fetching user:', error);
              resolve(null);
            });
          });

          if (userData !== null) {
            fetchedUserIds.add(userId);
          }

          return userData;
        } catch (error) {
          console.error('Error fetching user:', error);
          return null;
        }
      };

      const fetchDataForCelebs = async () => {
        try {
          setIsLoadingCelebs(true);
          const promises = Object.keys(celebs).map(oneId => fetchUser(oneId));
          const userDataArray = await Promise.all(promises);
          
          // Only update state if component is still mounted
          if (isMounted) {
            setCelebsData(
              parseCelebs(
                parseDesignInPersonas(userDataArray.filter(userData => userData !== null))
              )
            );
          }
        } catch (error) {
          console.log('Error fetching celebs:', error);
        } finally {
          if (isMounted) {
            setIsLoadingCelebs(false);
          }
        }
      };

      fetchDataForCelebs();

      // Cleanup function to prevent state updates after unmount
      return () => {
        isMounted = false;
      };
    }
  }, [celebs]);

  const getCelebCategory = (hdId) => {
    if (!Object.keys(celebs).length) return [];
    const types = celebs[hdId] ? celebs[hdId].type : [];
    return types;
  };

  const parseCelebs = (personas) => {
    const parseCeleb = (persona) => {
      persona = {
        ...persona,
        type: getCelebCategory(persona.user.token)
      }
      return persona;
    }

    if (!personas) return []
    personas = personas.map(one => ({
      ...parseCeleb(one)
    }))
    return personas
  };

  const $celebType = (typeId) => celebs_categories[typeId] ? celebs_categories[typeId][language] : '';

  const value = useMemo(() => ({
    celebs,
    celebsData,
    getCelebCategory,
    $celebType
  }), [celebs, celebsData, language]);

  return (
    <CelebsContext.Provider value={value}>
      {children}
    </CelebsContext.Provider>
  );
}

const CelebsConsumer = CelebsContext.Consumer;

export { CelebsConsumer, CelebsContext, CelebsProvider };


